import React from 'react';
import {
	createTheme,
	withStyles,
	makeStyles,
	ThemeProvider,
} from '@material-ui/core/styles';
import {
	Avatar,
  Container,
  CssBaseline,
  Divider,
  Grid,
	Paper,
  Typography,
} from '@material-ui/core';

import styled from "styled-components/macro";
import Navigation from './Navigation'

const pictureSource = 'https://portofolio-web.s3.ap-northeast-2.amazonaws.com/rico_1.png';

const useStyles = makeStyles((theme) => ({
	mainBlock: {
		// display: 'flex',
		// alignItems: 'center',
		marginTop: '20%',
		justifyContent: 'center',
		height: '100vh',
	},
	subheader: {
		fontWeight: 600,
		margin: '1.5rem 0'
	},
	content: {
		
	},
	rightGrid: {
		marginLeft: '2rem'
	}
}));

const Picture = styled.img.attrs({
	src: `${pictureSource}`
})`
	max-width:100%;
	height: auto;
`;

const customTheme = createTheme({
	typography: {
		fontFamily: [
			'Enriqueta', 'serif', '-apple-system', 'BlinkMacSystemFont','"Segoe UI"', 'Roboto', 
		].join(',')
	}
})

function Contact(props) {
	const classes = useStyles();

  return (
    <React.Fragment>
			<ThemeProvider theme={customTheme}>
				<Navigation />
				<Container maxWidth='md'>
					<Grid container component='div' className={classes.mainBlock}>
						<Grid item md sm>
							<Picture />
						</Grid>
						<Grid item md sm className={classes.rightGrid}>
							<Typography variant='h4' align='left' className={classes.subheader}>
								Email
							</Typography>
							<Typography variant='h5' align='left' className={classes.content}>
								ricovalentino94@gmail.com
							</Typography>
							<Typography variant='h4' align='left' className={classes.subheader}>
								Phone
							</Typography>
							<Typography variant='h5' align='left' className={classes.content}>
								+821072878722
							</Typography>
						</Grid>
					</Grid>
				</Container>
			</ThemeProvider>
    </React.Fragment>
  )
}

export default Contact;
